import {withStyles} from "@material-ui/core/styles";
import React from "react";

const styles = (theme) => ({
    fieldsContainer: {
        margin: '15px 0',
    },
});

const TemplateFieldContainer = withStyles(styles)(({children,classes}) => (
    <div  className={classes.fieldsContainer}>{children}</div>
));

export default TemplateFieldContainer;